import MenuBar from '../menuBar/MenuBar';
import Footer from './footer/Footer';
import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom';
import * as style from './style.css';
import HomePage from '../pages/home/homePage/HomePage';
import CatalogIndex from '../pages/catalog/CatalogIndex';
import ProductCard from '../pages/productCard/ProductCard';
import BasketPage from '../pages/basketPage/BasketPage';
import { ApplicationContext } from '../framework/framework/shared/ApplicationContext';
import RegisterPage from '../pages/userAccount/register/RegisterPage';
import ContactPage from '../pages/contact/ContactPage';
import TestBar from '../components/testBar/TestBar';
import ModalOnEvent from '../components/modal/ModalOnEvent';
import PrivacyIndexPage from '../pages/privacy/PrivacyIndexPage';
import SideBarOnEvent from '../components/modal/SideBarOnEvent';
import { StylesProvider } from '@material-ui/core';
import TaxonomyTree from '../pages/catalog/taxonomytree/TaxonomyTree';
import Messages from '../pages/catalog/messages/Messages';
import React = require('react');

interface IProps {
    appCtx: ApplicationContext;
    appName: string;
    buildTime: string;
    isTest: boolean;
}

interface IState {
}

export default class Application extends React.Component<IProps, IState> {
    render() {
        const renderMenuBar = true;
        const renderFooter = true;

        return (
            <div className={style.application}>
                <Messages singleMessage={true} />

                <StylesProvider injectFirst>

                    <Router basename={this.props.appCtx.baseName}>
                        {renderMenuBar && <MenuBar uriBuilder={(uri: string) => this.urlBuilder(uri)} appName={this.props.appName} />}
                        <div className={style.componentContainer}>
                            <Switch>
                                <Route path={'/rejestracja/:id?'} render={(props) => {
                                    const id = props.match.params.id;
                                    return <RegisterPage
                                        appCtx={this.props.appCtx}
                                        id={id} />;
                                }
                                }
                                />
                                <Route path={'/kontakt'} render={() => <ContactPage appCtx={this.props.appCtx} />} />
                                <Route path={'/logowanie'} render={() => <RegisterPage appCtx={this.props.appCtx} />} />
                                <Route path={'/koszyk'} render={() => <BasketPage controller={'Basket'} appCtx={this.props.appCtx} />} />
                                <Route path={'/produkty/:slug'} render={(props) => {
                                    console.log(props);
                                    return <ProductCard controller={'Product'} appCtx={this.props.appCtx} id={0} productName={props.match.params.slug} />;
                                }
                                } />
                                <Route path="/katalog/:slug"
                                    render={(props) => {
                                        console.log(props);
                                        const slug = props.match.params.slug;
                                        const search = this.extract(props.location.search, 'szukaj');
                                        const order = this.extract(props.location.search, 'order');
                                        return <>
                                            <div className={style.filterPanel}>
                                                <TaxonomyTree
                                                    appCtx={this.props.appCtx}
                                                    currentSlug={slug}
                                                    searchText={''}
                                                />
                                            </div>
                                            <CatalogIndex {...props}
                                                key={slug}
                                                slug={slug}
                                                searchText={search}
                                                order={order}
                                                controller={'Catalog'} appCtx={this.props.appCtx} />
                                        </>;
                                    }} />

                                <Route path="/katalog"
                                    render={(props) => {
                                        const search = this.extract(props.location.search, 'szukaj');
                                        return <>
                                            <div className={style.filterPanel}>
                                                <TaxonomyTree
                                                    appCtx={this.props.appCtx}
                                                    currentSlug={''}
                                                    searchText={''}
                                                />
                                            </div>
                                            <CatalogIndex key="catalog"
                                                slug={null}
                                                searchText={search}
                                                order={''}
                                                promoItems={false}
                                                controller={'Catalog'} appCtx={this.props.appCtx} />
                                        </>;
                                    }} />
                                <Route path="/promocje/:slug?"
                                    render={(props) => {
                                        debugger;
                                        const slug = props.match.params.slug || null;
                                        return <>
                                            <div className={style.filterPanel}>
                                                <TaxonomyTree
                                                    appCtx={this.props.appCtx}
                                                    currentSlug={''}
                                                    searchText={''}
                                                />
                                            </div>
                                            <CatalogIndex key={'promo'}
                                                slug={slug}
                                                searchText={''}
                                                order={''}
                                                promoItems={true}
                                                controller={'Catalog'} appCtx={this.props.appCtx} />
                                        </>;
                                    }} />

                                <Route path="/polityka_prywatnosci" >
                                    <PrivacyIndexPage appCtx={this.props.appCtx} url={'Home/privacy'}
                                    />
                                </Route>
                                <Route path="/ochrona_danych" >
                                    <PrivacyIndexPage appCtx={this.props.appCtx} url={'Home/inspector'}
                                    />
                                </Route>
                                <Route path="/" >
                                    <>
                                        <div className={style.filterPanel}>
                                            <TaxonomyTree
                                                appCtx={this.props.appCtx}
                                                currentSlug={''}
                                                searchText={''}
                                            />
                                        </div>
                                        <HomePage controller={'Home'} appCtx={this.props.appCtx} />
                                    </>
                                </Route>
                                {/* <Route render={(props)=>{console.log(props); return <>some component</>}  }></Route> */}
                            </Switch>
                        </div>
                        {renderFooter && <Footer appCtx={this.props.appCtx} appName={this.props.appName} buildTime={this.props.buildTime} />}
                        <ModalOnEvent />
                        <SideBarOnEvent />
                        {this.props.isTest && <TestBar />}
                    </Router>
                </StylesProvider>
            </div>

        );
    }

    extract(search: any, param: string): string {
        const searchParams = new URLSearchParams(search);
        return searchParams.get(param);
    }

    urlBuilder(uri: string) {
        return this.props.appCtx.buildUrl(uri);
    }
}
